import useApplicationConfig from '@/hooks/useApplicationConfig';
import { Box, CloseButton, Flex, Heading } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import NavItem from './nav-item.component';

interface ISidebarProps {
	onClose: () => void;
	links: Array<{
		text: string;
		icon: IconType;
		to: string;
	}>;
}

export default function SidebarContent(props: ISidebarProps) {
	const applicationConfig = useApplicationConfig();
	return (
		<Box
			data-id="sidebar"
			transition="3s ease"
			bg="white"
			borderRightWidth={1}
			overflow="hidden"
			borderRightColor="gray.200"
			w="full"
			minW="xs"
			h="full"
		>
			<Flex h="16" alignItems="center" mx="8" justifyContent="space-between">
				<Heading fontSize="xl" fontWeight={900} color="primary.500">
					{applicationConfig.name}
				</Heading>
				<CloseButton display={{ base: 'flex', lg: 'none' }} onClick={props.onClose} />
			</Flex>
			{props.links.map((link) => (
				<NavItem onClick={props.onClose} key={link.to} icon={link.icon} to={link.to} text={link.text} />
			))}
		</Box>
	);
}
